// src/services/api.js
import axios from "axios";

export const baseUrl = process.env.REACT_APP_API_BASE_URL; // replace with your base URL

const api = axios.create({
  baseURL: baseUrl,
  headers: {
    "Content-Type": "application/json",
  },
});

// Automatically attach token to every request if available
api.interceptors.request.use(
  (config) => {
    const userDetails = localStorage.getItem("userDetails");
    const idToken = userDetails ? JSON.parse(userDetails).idToken : null;
    if (idToken) {
      config.headers.Authorization = `Bearer ${idToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

let logoutHandler = () => {
  localStorage.removeItem("userDetails");
};

export const setLogoutHandler = (handler) => {
  logoutHandler = handler;
};

// Automatic logout if token is expired
api.interceptors.response.use(
  (response) => {
    if (
      response.data &&
      response.data.success === false &&
      (response.data.message === "Token expired" || response.status === 401)
    ) {
      logoutHandler();
    }
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      logoutHandler();
    }
    return Promise.reject(error);
  }
);

export default api;
